import { render, staticRenderFns } from "./officialAccountsTempMsg.vue?vue&type=template&id=6c6556c3&scoped=true&"
import script from "./officialAccountsTempMsg.vue?vue&type=script&lang=js&"
export * from "./officialAccountsTempMsg.vue?vue&type=script&lang=js&"
import style0 from "./officialAccountsTempMsg.vue?vue&type=style&index=0&id=6c6556c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6556c3",
  null
  
)

component.options.__file = "officialAccountsTempMsg.vue"
export default component.exports